import { ReactNode } from "react";
import { Stack } from "@mui/material";
import { Highlight } from "src/components/common/highlight";
import { Typography } from "src/components-mui/base/typography/typography";

interface ISearchItemContentStackProps {
    primaryText: string;
    secondaryText?: string;
    query?: string;
    suffix?: ReactNode;
}

export const SearchItemContentStack = ({ primaryText, secondaryText, query, suffix }: ISearchItemContentStackProps) => {
    return (
        <>
            <Stack
                component="span"
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 0, sm: 1 }}
                sx={{
                    flexGrow: 1,
                    alignItems: "baseline",
                    overflow: "hidden",
                    color: "gray.800",
                }}
            >
                <Typography component="span" noWrap sx={{ maxWidth: "100%", wordBreak: "break-all" }}>
                    <Highlight source={primaryText} target={query} />
                </Typography>
                {secondaryText && (
                    <Typography
                        component="span"
                        noWrap
                        sx={{
                            fontSize: "xs",
                            borderLeft: { xs: "none", sm: "1px solid" },
                            borderColor: { sm: "gray.800" },
                            pl: { xs: 0, sm: 1 },
                            maxWidth: "100%",
                            wordBreak: "break-all",
                        }}
                    >
                        <Highlight source={secondaryText} target={query} />
                    </Typography>
                )}
            </Stack>

            {suffix}
        </>
    );
};
